const en = {
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    update: 'Update',
    close: 'Close',
    confirm: 'Confirm',
    search: 'Search',
    filter: 'Filter',
    reset: 'Reset',
    refresh: 'Refresh',
    view: 'View',
    print: 'Print',
    export: 'Export',
    all: 'All',
    none: 'None',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    optional: 'optional',
    back: 'Back',
    next: 'Next',
    submit: 'Submit',
    clear: 'Clear',
    copy: 'Copy',
    copied: 'Copied',
    select: 'Select',
    chooseFile: 'Choose file',
    noFileChosen: 'No file chosen',
    noData: 'No data available',
    actions: 'Actions',
    status: 'Status',
    date: 'Date',
    time: 'Time',
    amount: 'Amount',
    total: 'Total',
    quantity: 'Quantity',
    price: 'Price',
    name: 'Name',
    description: 'Description',
    notes: 'Notes',
    details: 'Details',
    by: 'By',
    from: 'From',
    to: 'To',
    of: 'of',
    showing: 'Showing',
    previous: 'Previous',
    items: 'Items',
    item: 'Item',
    others: 'Others',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This Week',
    lastWeek: 'Last Week',
    week: 'Week',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    thisYear: 'This Year',
    lastYear: 'Last Year',
    last7Days: 'Last 7 Days',
    custom: 'Custom',
    questionMark: '?',
    deleted: 'Deleted',
    system: 'System',
    product: 'Product',
    products: 'Products',
    category: 'Category',
  },

  // Login
  login: {
    title: 'Numuw Counter',
    subtitle: 'Sign in to your account',
    username: 'Username',
    accountNo: 'Account number',
    password: 'Password',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    signIn: 'Sign In',
    noAccount: "Don't have an account?",
    requestDemo: 'Request a demo here',
    signingIn: 'Signing In...',
    forgotPassword: 'Forgot password?',
    invalidCredentials: 'Invalid username or password',
    incorrectPassword: 'Password is incorrect',
    accountDisabled: 'Account is disabled',
    loginFailed: 'Login failed',
    failedToFetch: 'Failed to fetch',
    sessionConflict: 'Session Conflict',
    registerLocked: 'Register is locked by another cashier',
    activeSessionOnOtherRegister: 'You have an active session on another register',
    activeSessionOnOtherRegisterMessage: 'Please go to {register} and close your session before using this register.',
    contactManager: 'Please contact a manager to resolve this issue',
    language: 'Language',
    english: 'English',
    arabic: 'العربية',
  },

  subscription: {
    expiredTitle: 'Subscription inactive',
    expiredMessage: 'Your store subscription is not active. Please contact Numuw support.',
  },

  // Layout / Navigation
  nav: {
    pos: 'POS',
    dashboard: 'Insights',
    inventory: 'Inventory',
    offers: 'Offers',
    sessions: 'Sessions',
    orders: 'Orders',
    sales: 'Sales',
    refunds: 'Refunds',
    expenses: 'Expenses',
    purchases: 'Purchases',
    customers: 'Customers',
    deliveryPersonnel: 'Delivery Personnel',
    monthlyClosing: 'Monthly Closing',
    audit: 'Audit Actions',
    settings: 'Settings',
    logout: 'Logout',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    black: 'Black',
  },

  // POS
  pos: {
    noRecordedStock: '0 stock',
    cashReceivedOptionalHint: 'Leave empty if exact amount',
    cart: 'Cart',
    emptyCart: 'Cart is empty',
    scanBarcode: 'Scan barcode...',
    searchProducts: 'Search products...',
    addToCart: 'Add to Cart',
    removeFromCart: 'Remove',
    clearCart: 'Clear Cart',
    checkout: 'Checkout',
    subtotal: 'Subtotal',
    tax: 'Tax',
    discount: 'Discount',
    discountNotes: 'Discount notes',
    discountNotesPlaceholder: 'Optional note (max 50 characters)',
    discountApprovalTitle: 'Discount approval',
    discountApprovalSubtitle: 'Discount {percent}% — total {total}',
    discountCode: 'Discount Code',
    discountCodePlaceholder: 'Scan barcode or enter discount code',
    discountApprovedBy: 'Approved by',
    completeSale: 'Complete sale',
    promo: 'Promo',
    grandTotal: 'Grand Total',
    paymentMethod: 'Payment Method',
    cash: 'Cash',
    card: 'Card',
    instapay: 'InstaPay',
    wallet: 'Wallet',
    mixed: 'Mixed',
    electronic: 'Electronic',
    cashReceived: 'Cash Received',
    change: 'Change',
    transactionNo: 'Transaction No.',
    processPayment: 'Process Payment',
    processing: 'Processing...',
    paymentSuccess: 'Payment Successful',
    printReceipt: 'Print Receipt',
    newSale: 'New Sale',
    holdOrder: 'Hold Order',
    heldOrders: 'Held Orders',
    orderMode: 'Order Mode',
    inStore: 'In-Store',
    delivery: 'Delivery',
    deliveryInfo: 'Delivery Information',
    customerName: 'Customer Name',
    customerPhone: 'Phone Number',
    customerAddress: 'Address',
    deliveryRegion: 'Delivery Region',
    deliveryPerson: 'Delivery Person',
    deliveryPersonnelList: 'Delivery Personnel',
    selectDeliveryPerson: 'Select delivery person',
    deliveryFee: 'Delivery Fee',
    noDeliveryFee: 'No delivery fee',
    newCustomer: 'New customer - details will be saved automatically',
    existingCustomer: 'Existing customer found - details auto-filled',
    clearDelivery: 'Clear',
    confirmDelivery: 'Confirm',
    selectRegion: 'Select Region',
    noSession: 'No Open Session',
    openSession: 'Open Session',
    closeSession: 'Close Session',
    sessionRequired: 'Please open a session to start selling',
    outOfStock: 'Out of Stock',
    insufficientStock: 'Insufficient Stock',
    availableStock: 'Available',
    pricePerUnit: 'Price per',
    kg: 'KG',
    pc: 'pc',
    pcs: 'pcs',
    units: 'units',
    categories: 'Categories',
    allCategories: 'All Categories',
    offersCategory: 'Offers',
    products: 'Products',
    noProducts: 'No products found',
    refund: 'Refund',
    enterOrderUUID: 'Enter Order UUID',
    electronicPayment: 'Electronic Payment',
    cashPayment: 'Cash Payment',
    cardPayment: 'Card Payment',
    instapayPayment: 'Instapay Payment',
    walletPayment: 'Wallet Payment',
    mixedPayment: 'Mixed Payment',
    totalAmount: 'Total Amount',
    cashReceivedEgp: 'Cash Received (EGP)',
    paymentType: 'Payment Type',
    transactionNumber: 'Transaction Number',
    enterTransactionNumber: 'Enter {method} transaction number',
    cashAmountEgp: 'Cash Amount (EGP)',
    mixedCashAmountHintBeforeZero: 'Amount must be greater than or equal to ',
    mixedCashAmountHintBetween: ' and less than ',
    secondaryPaymentMethod: 'Secondary Payment Method',
    cardAmountAuto: 'Card Amount (EGP) - Auto-calculated',
    cardTransactionNumber: 'Card Transaction Number',
    enterCardTransaction: 'Enter card transaction number',
    instapayAmountAuto: 'Instapay Amount (EGP) - Auto-calculated',
    instapayTransactionNumber: 'Instapay Transaction Number',
    enterInstapayTransaction: 'Enter instapay transaction number',
    walletAmountAuto: 'Wallet Amount (EGP) - Auto-calculated',
    walletTransactionNumber: 'Wallet Transaction Number',
    enterWalletTransaction: 'Enter wallet transaction number',
    paymentProcessed: 'Payment Processed',
    receiptPrinted: 'Receipt Printed',
    saveAndCloseOrder: 'Save and Close Order',
    saving: 'Saving...',
    sessionOrders: 'Session Orders',
    sessionRefunds: 'Session Refunds',
    noSessionOrders: 'No orders found for the selected filters.',
    noSessionRefunds: 'No refunds found in this session.',
    sessionOrdersLoadError: 'Failed to load session orders.',
    sessionRefundsLoadError: 'Failed to load session refunds.',
    searchByPhone: 'Search by phone number',
    allPaymentMethods: 'All payment methods',
    allOrderTypes: 'All order types',
    allDeliveryPersons: 'All delivery persons',
    allStatuses: 'All statuses',
    completed: 'Completed',
    refunded: 'Refunded',
    partiallyRefunded: 'Partially Refunded',
  },

  // Receipt
  receipt: {
    receipt: 'Receipt',
    receiptNo: 'Receipt #',
    transactionId: 'Transaction ID',
    itemsTotal: 'Items Total',
    orderNo: 'Order No.',
    date: 'Date',
    cashier: 'Cashier',
    items: 'Items',
    subtotal: 'Subtotal',
    discount: 'Discount',
    tax: 'Tax',
    deliveryFee: 'Delivery Fee',
    total: 'Total',
    paymentMethod: 'Payment',
    cashReceived: 'Cash Received',
    change: 'Change',
    thankYou: 'Thank you for your purchase!',
    visitAgain: 'Please visit again',
    visitUsOn: 'Visit us on',
    refundReceipt: 'Refund Receipt',
    originalOrder: 'Original Order',
    refundedItems: 'Refunded Items',
    refundAmount: 'Refund Amount',
    cashAmount: 'Cash Amount',
    cardAmount: 'Card Amount',
    instapayAmount: 'InstaPay Amount',
    walletAmount: 'Wallet Amount',
    cardTransactionNo: 'Card Transaction No.',
    instapayTransactionNo: 'InstaPay Transaction No.',
    walletTransactionNo: 'Wallet Transaction No.',
    refundReason: 'Reason',
    approvedBy: 'Approved By',
    barcode: 'Barcode',
  },

  // Dashboard
  dashboard: {
    welcome: 'Welcome',
    overview: 'Overview',
    todaySales: "Today's Sales",
    todayProfit: "Today's Revenue",
    todayRevenue: "Today's Revenue",
    totalOrders: 'Total Orders Today',
    totalRevenue: 'Total Revenue',
    averageOrder: 'Average Order',
    lowStockItems: 'Low Stock Items',
    recentTransactions: 'Recent Transactions',
    topSellingProducts: 'Top 10 Selling Products',
    mostRefundedProducts: 'Most Refunded Products',
    revenueComparison: 'Sales & Revenue Breakdown',
    salesByCategory: 'Sales by Category',
    salesTrend: 'Sales Trend',
    noSalesData: 'No sales data available',
    noRefundData: 'No refund data available',
    period: 'Period',
    revenue: 'Revenue',
    chartProfitBarLabel: 'Revenue',
    chartSales: 'Sales',
    orders: 'Orders',
    refunds: 'Refunds',
    expensesChart: 'Expenses',
    purchasesChart: 'Purchases',
    paymentMethods: 'Payment Methods',
    paymentSplit: 'Payment split',
    refundsChart: 'Refunds',
    netRevenue: 'Net Revenue',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
  },

  // Inventory
  inventory: {
    adjustStock: 'Adjust Stock',
    currentStock: 'Current stock',
    adjustBy: 'Adjust by',
    newStock: 'New stock',
    stockCannotGoBelowZero: 'Stock cannot be saved below 0; it will be set to 0.',
    stockAdjusted: 'Stock updated',
    oversold: 'Oversold',
    downloadExcel: 'Download Excel',
    excelExport: {
      sheetInventory: 'Inventory',
      productName: 'Product Name',
      sku: 'SKU',
      category: 'Category',
      uncategorized: 'Uncategorized',
      unitType: 'Unit Type',
      costPrice: 'Cost Price',
      sellingPrice: 'Selling Price',
      stock: 'Stock',
      total: 'Total',
    },
    inventory: 'Inventory',
    inventoryManagement: 'Inventory Management',
    manageStock: 'Manage products and stock levels',
    products: 'Products',
    categories: 'Categories',
    addProduct: 'Add Product',
    addItem: 'Add Item',
    editProduct: 'Edit Product',
    editItem: 'Edit Item',
    productDetails: 'Product Details',
    deleteProduct: 'Delete Product',
    deleteItem: 'Delete Item',
    productName: 'Product Name',
    itemName: 'Item Name',
    sku: 'SKU',
    skuAlreadyExists: 'This SKU already exists',
    productNameAlreadyExists: 'A product with this name already exists',
    skuOptional: 'SKU (Optional)',
    barcode: 'Barcode',
    costPrice: 'Cost Price',
    profitMargin: 'Profit Margin',
    sellingPrice: 'Selling Price',
    salePrice: 'Sale Price',
    stockQuantity: 'Stock Quantity',
    unitType: 'Unit Type',
    piece: 'Piece',
    perPiece: 'Piece',
    kilogram: 'Kilogram (KG)',
    perKg: 'KG',
    category: 'Category',
    selectCategory: 'Select Category',
    image: 'Image',
    imageOptional: 'Image (Optional)',
    uploadImage: 'Upload Image',
    selectImage: 'Select Image',
    noImage: 'No Image',
    invalidImage: 'Invalid image',
    enterImageUrl: 'Enter image URL',
    imageUrlHelp: 'Enter a URL or upload a local image file',
    browse: 'Browse',
    addCategory: 'Add Category',
    addNewCategory: 'Add New Category',
    editCategory: 'Edit Category',
    deleteCategory: 'Delete Category',
    categoryName: 'Category Name',
    categoryNameUnique: 'This category name already exists',
    categoryColor: 'Category Color',
    color: 'Color',
    manageCategories: 'Manage Categories',
    categoryManagement: 'Category Management',
    noCategories: 'No categories yet.',
    lowStock: 'Low Stock',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',
    lowStockWarning: 'items low on stock (< 10 units)',
    allProducts: 'All Products',
    lowStockOnly: 'Low Stock Only',
    andMore: 'and {count} more',
    allCategories: 'All Categories',
    searchProducts: 'Search by name or SKU...',
    noItemsFound: 'No items found',
    tryDifferentSearch: 'Try different search or filter',
    addFirstItem: 'Add your first item to get started',
    uncategorized: 'Uncategorized',
    saving: 'Saving...',
    confirmDeleteProduct: 'Are you sure you want to delete this product?',
    confirmDeleteCategory: 'Are you sure you want to delete this category?',
    deleteItemConfirm: 'This cannot be undone.',
    deleteCategoryConfirm: 'This will affect products in this category.',
    productAdded: 'Product added successfully',
    productUpdated: 'Product updated successfully',
    productDeleted: 'Product deleted successfully',
    categoryAdded: 'Category added successfully',
    categoryUpdated: 'Category updated successfully',
    categoryDeleted: 'Category deleted successfully',
  },

  offers: {
    pageSubtitle: 'Create and manage product bundle offers',
    downloadExcel: 'Download Excel',
    excelExport: {
      sheetOffers: 'Offers',
      sheetComponents: 'Offer Components',
      offerName: 'Offer Name',
      sku: 'SKU',
      previewCost: 'Preview Cost',
      sellingPrice: 'Selling Price',
      profitMargin: 'Profit Margin',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      total: 'Total',
      productName: 'Product Name',
      productSku: 'Product SKU',
      quantity: 'Quantity',
      unitType: 'Unit Type',
      unitCost: 'Unit Cost',
      totalCost: 'Total Cost',
      noComponents: 'No components',
    },
    offerName: 'Offer Name',
    sku: 'Offer SKU',
    addOffer: 'Add Offer',
    editOffer: 'Edit Offer',
    deleteOffer: 'Delete Offer',
    deleteConfirm: 'Delete "{name}"? Past sales will remain in reports.',
    components: 'Components',
    addComponent: 'Add Product',
    selectProduct: 'Select product',
    productSearchPlaceholder: 'Enter or scan barcode, SKU, or product name...',
    productNotFound: 'Product not found',
    productAlreadyInOffer: 'This product is already in the offer',
    previewCost: 'Preview Cost',
    searchOffers: 'Search offers...',
    totalOffers: 'Total Offers',
    activeOffers: 'Active',
    inactiveOffers: 'Inactive',
    noOffers: 'No offers yet',
    nameRequired: 'Offer name is required',
    nameMaxLength: 'Offer name must not exceed 35 characters',
    sellingPriceRequired: 'Selling price must be greater than 0',
    componentsRequired: 'Add at least one product to the offer',
    skuAlreadyExists: 'This SKU already exists',
    created: 'Offer created successfully',
    updated: 'Offer updated successfully',
    deleted: 'Offer deleted successfully',
    deactivatedOnDelete: 'Offer deactivated (has past sales)',
    activated: 'Offer activated successfully',
    deactivatedStatus: 'Offer deactivated successfully',
    activate: 'Activate',
    deactivate: 'Deactivate',
    activeOffer: 'Active (visible in POS)',
    viewOffer: 'View offer',
    offerDetails: 'Offer Details',
    noComponents: 'No products in this offer',
    lineCost: 'Total Cost',
    categoryName: 'Offers',
  },

  // Expenses
  expenses: {
    downloadExcel: 'Download Excel',
    excelExport: {
      sheetCategories: 'Categories',
      sheetExpenses: 'Expenses',
      name: 'Name',
      category: 'Category',
      uncategorized: 'Uncategorized',
      date: 'Date',
      amount: 'Amount',
      total: 'Total',
    },
    title: 'Expenses',
    subtitle: 'Track and manage business expenses',
    addExpense: 'Add Expense',
    editExpense: 'Edit Expense',
    deleteExpense: 'Delete Expense',
    expenseName: 'Expense Name',
    amount: 'Amount',
    category: 'Category',
    selectCategory: 'Select Category',
    date: 'Date',
    totalExpenses: 'Total Expenses',
    thisMonth: 'This Month',
    expenseCount: 'Expense Count',
    manageCategories: 'Manage Categories',
    addCategory: 'Add Category',
    editCategory: 'Edit Category',
    deleteCategory: 'Delete Category',
    categoryName: 'Category Name',
    categoryNameUnique: 'This category name already exists',
    noCategories: 'No expense categories yet.',
    noExpenses: 'No expenses found',
    tryDifferentFilters: 'Try different filters or date range',
    addFirstExpense: 'Add your first expense to get started',
    searchPlaceholder: 'Search by name...',
    deleteExpenseConfirm: 'This cannot be undone.',
    deleteCategoryConfirm: 'Delete "{name}"? All expenses in this category will be removed.',
    nameRequired: 'Expense name is required',
    categoryRequired: 'Please select a category',
    invalidAmount: 'Amount must be greater than 0',
  },

  purchases: {
    downloadExcel: 'Download Excel',
    excelExport: {
      sheetCategories: 'Categories',
      sheetPurchases: 'Purchases',
      totalPurchasesByCategory: 'Total Purchases',
      productName: 'Product Name',
      category: 'Category',
      uncategorized: 'Uncategorized',
      unitType: 'Unit Type',
      supplier: 'Supplier',
      date: 'Date',
      quantity: 'Quantity',
      unitPrice: 'Unit price',
      unitSellingPrice: 'Unit selling price',
      oldCostPrice: 'Old cost price',
      oldSellingPrice: 'Old selling price',
      inventoryBefore: 'Inventory before',
      inventoryAfter: 'Inventory after',
      totalPrice: 'Total Price',
      total: 'Total',
    },
    title: 'Purchases',
    subtitle: 'Track inventory purchases and suppliers',
    addPurchase: 'Add Purchase',
    editPurchase: 'Edit Purchase',
    deletePurchase: 'Delete Purchase',
    deletePurchaseConfirm: 'Delete purchase of {quantity} x "{product}"? Stock will be reduced. This cannot be undone.',
    manageSuppliers: 'Manage Suppliers',
    barcodePlaceholder: 'Enter or scan barcode, SKU, or product name...',
    supplier: 'Supplier',
    selectSupplier: 'Select Supplier',
    costPrice: 'Cost Price',
    sellingPrice: 'Selling Price',
    quantity: 'Quantity',
    quantityHintPiece: 'Whole numbers only — this product is tracked by piece.',
    quantityHintKg: 'Up to 3 decimal places — this product is tracked by kg.',
    inventoryBeforeAfter: 'New inventory: {before} + {quantity} = {after}',
    date: 'Date',
    totalPurchases: 'Total Purchases',
    purchaseCount: 'Purchase Count',
    todayPurchases: 'Purchases Today',
    todayTotal: 'Today Total',
    noPurchases: 'No purchases found',
    tryDifferentFilters: 'Try different filters or date range',
    addFirstPurchase: 'Add your first purchase to get started',
    searchPlaceholder: 'Search by product or SKU...',
    productNotFound: 'Product not found',
    changeProduct: 'Change',
    supplierName: 'Supplier Name',
    supplierPhone: 'Phone',
    addSupplier: 'Add Supplier',
    editSupplier: 'Edit Supplier',
    deleteSupplier: 'Delete Supplier',
    deleteSupplierConfirm: 'Delete "{name}"? This cannot be undone.',
    supplierHasPurchases: 'Cannot delete supplier with existing purchases',
    supplierPhoneUnique: 'This number already exists',
    supplierNameUnique: 'A supplier with this name already exists',
    noSuppliers: 'No suppliers yet. Add a supplier first.',
    searchSuppliersPlaceholder: 'Search by name or phone…',
    suppliersNoSearchMatches: 'No suppliers match your search.',
    purchaseDetails: 'Purchase Details',
    productData: 'Product Data',
    supplierData: 'Supplier Data',
    purchaseSummary: 'Purchase Summary',
    oldCostPrice: 'Old Cost Price',
    oldSellingPrice: 'Old Selling Price',
    oldInventory: 'Old Inventory',
    newInventory: 'New Inventory',
  },

  monthlyClosing: {
    title: 'Monthly Closing',
    subtitle: 'Calculate and save monthly totals for expenses, sales, and purchases',
    closingDate: 'Closing Date',
    calculateAndSave: 'Calculate & Save',
    startDate: 'Start Date',
    startDateOptionalHint: 'Leave empty to calculate automatically from the closing date (one month before, inclusive).',
    startDateAfterClosing: 'Start date must be on or before the closing date.',
    totalExpenses: 'Total Expenses',
    totalSales: 'Total Sales',
    totalPurchases: 'Total Purchases',
    totalSalesRevenue: 'Total Revenue',
    totalRefunds: 'Total Refunds',
    pastClosings: 'Past Closings',
    noClosings: 'No monthly closings yet. Enter a closing date and click Calculate & Save.',
    loadFailed: 'Failed to load monthly closings',
    saveFailed: 'Failed to save monthly closing',
    closingDateRequired: 'Closing date is required',
    alreadyExists: 'A closing already exists for this period (same start date through closing date).',
    deleteConfirm: 'Delete monthly closing for {date}?',
    deleteFailed: 'Failed to delete monthly closing',
    download: 'Download Excel',
    downloading: 'Downloading...',
    downloadFailed: 'Failed to download export',
    excelExport: {
      sheetSummary: 'Summary',
      sheetSales: 'Sales',
      sheetPurchases: 'Purchases',
      sheetExpenses: 'Expenses',
      sheetRefunds: 'Refunds',
      sheetInventory: 'Inventory',
      startDate: 'Start Date',
      endDate: 'End Date',
      closingDate: 'Closing Date',
      totalExpenses: 'Total Expenses',
      totalSales: 'Total Sales',
      totalPurchases: 'Total Purchases',
      totalRefunds: 'Total Refunds',
      totalPurchasesByCategory: 'Total Purchases',
      totalRevenueProfit: 'Total Revenue',
      productName: 'Product Name',
      sku: 'SKU',
      category: 'Category',
      uncategorized: 'Uncategorized',
      offerCategory: 'Offer',
      unitType: 'Unit Type',
      soldQty: 'Sold Qty',
      revenue: 'Sales',
      revenueProfit: 'Revenue',
      productCode: 'Product Code',
      supplier: 'Supplier',
      quantity: 'Quantity',
      unitPrice: 'Unit Price',
      unitSellingPrice: 'Unit selling price',
      oldCostPrice: 'Old cost price',
      oldSellingPrice: 'Old selling price',
      inventoryBefore: 'Inventory before',
      inventoryAfter: 'Inventory after',
      totalPrice: 'Total Price',
      date: 'Date',
      name: 'Name',
      code: 'Code',
      amount: 'Amount',
      costPrice: 'Cost Price',
      sellingPrice: 'Selling Price',
      stock: 'Stock',
      total: 'Total',
      refundedQty: 'Refunded qty',
      refundedAmount: 'Refunded amount',
      refundProductCategory: 'Product category',
    },
  },

  // Customers
  customers: {
    downloadExcel: 'Download Excel',
    excelExport: {
      sheetCustomers: 'Customers',
      name: 'Name',
      phone: 'Phone',
      address: 'Address',
      totalOrders: 'Total Orders',
      totalSpent: 'Total Spent',
      total: 'Total',
    },
    title: 'Customers',
    subtitle: 'View and manage customer information',
    addCustomer: 'Add Customer',
    editCustomer: 'Edit Customer',
    customerDetails: 'Customer Details',
    totalOrders: 'Total Orders',
    totalPurchases: 'Total Purchases',
    noCustomers: 'No customers found',
    tryDifferentSearch: 'Try a different search',
    addFirstCustomer: 'Add your first customer or they will appear when orders are placed',
    searchPlaceholder: 'Search by name or phone...',
    nameRequired: 'Customer name is required',
    phoneRequired: 'Phone number is required',
    phoneUnique: 'This number already exists',
    deleteCustomer: 'Delete Customer',
    deleteCustomerConfirm: 'Delete "{name}"? This cannot be undone. Orders will be unlinked from this customer.',
  },

  deliveryPersons: {
    downloadExcel: 'Download Excel',
    excelExport: {
      sheetDelivery: 'Delivery Personnel',
      name: 'Name',
      phone: 'Phone',
      total: 'Total',
    },
    title: 'Delivery Personnel',
    subtitle: 'Manage delivery persons for delivery orders',
    addPerson: 'Add Delivery Person',
    editPerson: 'Edit Delivery Person',
    deletePerson: 'Delete Delivery Person',
    addFirstPerson: 'Add delivery persons to assign them to delivery orders in POS.',
    searchPlaceholder: 'Search by name or phone...',
    noResults: 'No delivery persons found',
    tryDifferentSearch: 'Try a different search',
  },

  // Sessions
  sessions: {
    downloadExcel: 'Download Excel',
    searchBySessionNo: 'Search by session no...',
    excelExport: {
      sheetSessions: 'Sessions',
      cashier: 'Cashier',
      register: 'Register',
      startTime: 'Start Time',
      endTime: 'End Time',
      status: 'Status',
      openingCash: 'Opening Cash',
      expectedCash: 'Expected Cash',
      expectedCard: 'Expected Card',
      expectedInstapay: 'Expected InstaPay',
      expectedWallet: 'Expected Wallet',
      refundAmount: 'Refund Amount',
      receivedCash: 'Received Cash',
      cashDiff: 'Cash diff',
      closedBy: 'Closed By',
      reviewedBy: 'Reviewed By',
      total: 'Total',
    },
    sessions: 'Sessions',
    currentSession: 'Current Session',
    openSession: 'Open Session',
    closeSession: 'Close Session',
    viewSession: 'View Session',
    sessionDetails: 'Session Details',
    openingCash: 'Opening Cash',
    openingCard: 'Opening Card Balance',
    closingCash: 'Closing Cash',
    netCash: 'Net Cash',
    closingCard: 'Closing Card',
    closingInstapay: 'Closing InstaPay',
    closingWallet: 'Closing Wallet',
    expectedCash: 'Expected Cash',
    expectedCard: 'Expected Card',
    expectedInstapay: 'Expected InstaPay',
    expectedWallet: 'Expected Wallet',
    difference: 'Difference',
    cashDifference: 'Cash Difference',
    cardDifference: 'Card Difference',
    instapayDifference: 'InstaPay Difference',
    walletDifference: 'Wallet Difference',
    totalSales: 'Total Sales',
    totalRefunds: 'Total Refunds',
    netSales: 'Net Sales',
    startTime: 'Start Time',
    endTime: 'End Time',
    duration: 'Duration',
    cashier: 'Cashier',
    register: 'Register',
    status: 'Status',
    open: 'Open',
    closed: 'Closed',
    forceClosed: 'Force Closed',
    reviewed: 'Reviewed',
    notes: 'Notes',
    closingNotes: 'Closing Notes',
    reviewNotes: 'Review Notes',
    reviewedBy: 'Reviewed By',
    reviewSession: 'Review Session',
    forceClose: 'Force Close',
    confirmForceClose: 'Are you sure you want to force close this session?',
    sessionOpened: 'Session opened successfully',
    sessionClosed: 'Session closed successfully',
    openSessionSubtitle: 'Enter opening cash.',
    openingCashLabel: 'Opening cash (EGP)',
    openingSessionInProgress: 'Opening session…',
    loadingSession: 'Loading session...',
    registerLocked: 'Register Locked',
    registerLockedMessage: 'This register has an active session',
    registerLockedFullMessage: '{name} has an open session on this register. They must log in and close it, or a manager/admin must force-close it.',
    registerLockedOptions: 'Options:',
    registerLockedOption1: 'must log in and close their session',
    registerLockedOption2: 'A manager or admin must force-close the session',
    startedAt: 'Started',
    closingCashLabel: 'Closing Cash (EGP)',
    closingSessionInProgress: 'Closing...',
    opening: 'Opening:',
    allCashiers: 'All Cashiers',
    allRegisters: 'All Registers',
    allStatuses: 'All Statuses',
    filterByDate: 'Filter by Date',
    filterByCashier: 'Filter by Cashier',
    filterByRegister: 'Filter by Register',
    filterByStatus: 'Filter by Status',
    sessionClosingReceipt: 'Session Closing Receipt',
    sessionNo: 'Session No',
    sessionId: 'Session ID',
    openingBalance: 'Opening Balance',
    openingCardAt: 'Opening Card (at)',
    closingBalance: 'Closing Balance',
    closingCardAt: 'Closing Card (at)',
    closingCardNet: 'Closing Card (net)',
    expectedClosing: 'Expected Closing',
    sales: 'Sales',
    expectedCashFormula: 'Expected cash: opening + sales - refund',
    expectedCashReceipt: 'Expected Cash: {amount}',
  },

  // Reports / Orders
  reports: {
    downloadExcel: 'Download Excel',
    excelExport: {
      sheetOrdersInStore: 'In-Store Orders',
      sheetOrdersDelivery: 'Delivery Orders',
      receiptNo: 'Receipt No.',
      date: 'Date',
      customer: 'Customer',
      deliveryRegion: 'Delivery Region',
      deliveryPerson: 'Delivery Person',
      cashier: 'Cashier',
      paymentMethod: 'Payment Method',
      promoName: 'Promo Name',
      promoPercentage: 'Promo %',
      discountApprover: 'Discount Approver',
      discount: 'Discount',
      tax: 'Tax',
      total: 'Total',
      status: 'Status',
      discountNotes: 'Discount Notes',
      grandTotal: 'Grand Total',
    },
    orders: 'Orders',
    sales: 'Sales',
    salesReport: 'Sales Report',
    orderDetails: 'Order Details',
    orderNo: 'Order No.',
    receiptNo: 'Receipt No.',
    orderDate: 'Order Date',
    customer: 'Customer',
    walkIn: 'Walk-in',
    paymentMethod: 'Payment Method',
    totalAmount: 'Total Amount',
    status: 'Status',
    completed: 'Completed',
    refunded: 'Refunded',
    partiallyRefunded: 'Partially Refunded',
    viewOrder: 'View Order',
    printReceipt: 'Print Receipt',
    filterByDate: 'Filter by Date',
    filterByPayment: 'Filter by Payment',
    filterByStatus: 'Filter by Status',
    allPaymentMethods: 'All Payment Methods',
    allStatuses: 'All Statuses',
    totalSales: 'Total Sales',
    totalOrders: 'Total Orders',
    averageOrder: 'Average Order',
    searchByUUID: 'Search by Order UUID...',
    searchByPhone: 'Search by phone...',
    searchOrders: 'Search receipt, phone, or session #...',
    noOrders: 'No orders found',
    orderItems: 'Order Items',
    paymentDetails: 'Payment Details',
    orderType: 'Order type',
    session: 'Session',
    discount: 'Discount',
    withDiscount: 'With discount',
    withoutDiscount: 'Without discount',
  },

  // Sales (product sold quantities)
  sales: {
    title: 'Sales',
    byProduct: 'By Product',
    byOffer: 'By Offer',
    offerName: 'Offer Name',
    bundlesSold: 'Bundles Sold',
    searchOffer: 'Search offer...',
    totalUnitsSold: 'Total Units Sold',
    totalRevenue: 'Total Sales',
    soldQuantity: 'Sold Quantity',
    revenue: 'Sales',
    revenueProfit: 'Revenue',
    searchProduct: 'Search Product',
    noSalesData: 'No sales data for the selected period',
    downloadExcel: 'Download',
    excelExport: {
      sheetSummary: 'Categories',
      sheetSales: 'Sales',
      sheetOfferSales: 'Offer Sales',
      offerName: 'Offer Name',
      bundlesSold: 'Bundles Sold',
      productName: 'Product Name',
      productCode: 'Product Code',
      sku: 'SKU',
      category: 'Category',
      uncategorized: 'Uncategorized',
      unitType: 'Unit Type',
      soldQty: 'Sold Qty',
      revenue: 'Sales',
      revenueProfit: 'Profit',
      total: 'Total',
    },
  },

  // Refunds
  refunds: {
    downloadExcel: 'Download Excel',
    excelExport: {
      sheetRefunds: 'Refunds',
      receiptNo: 'Receipt No.',
      date: 'Date',
      orderCashier: 'Order cashier',
      refundCashier: 'Refunded by',
      cashier: 'Cashier',
      approvedBy: 'Approved By',
      reason: 'Reason',
      amount: 'Amount',
      status: 'Status',
      totalRefunded: 'Total Refunded',
    },
    refunds: 'Refunds',
    refundList: 'Refund List',
    newRefund: 'New Refund',
    refundDetails: 'Refund Details',
    refundNo: 'Refund No.',
    originalOrder: 'Original Order',
    refundDate: 'Refund Date',
    refundAmount: 'Refund Amount',
    refundReason: 'Reason',
    approvedBy: 'Approved By',
    orderCashier: 'Order cashier',
    refundCashier: 'Refunded by',
    processedBy: 'Processed By',
    orderCashier: 'Original Cashier',
    refundedItems: 'Refunded Items',
    selectItems: 'Select Items to Refund',
    refundQuantity: 'Refund Quantity',
    restock: 'Restock',
    restockItem: 'Restock Item',
    processRefund: 'Process Refund',
    confirmRefund: 'Confirm Refund',
    refundSuccess: 'Refund processed successfully',
    enterReason: 'Enter refund reason',
    reasonRequired: 'Reason is required',
    noItemsSelected: 'No items selected for refund',
    refundQuantityRequired: 'Please enter a refund quantity greater than zero',
    maxRefundExceeded: 'Refund amount exceeds maximum allowed',
    searchByOrderUUID: 'Search by Order UUID...',
    searchByReceiptNo: 'Search by receipt number...',
    filterByDate: 'Filter by Date',
    noRefunds: 'No refunds found',
    totalRefundedAmount: 'Total refunded (EGP)',
    totalRefunded: 'Total refunded',
    fullRefund: 'Full Refund',
    partialRefund: 'Partial Refund',
    statusRejected: 'Rejected',
    statusPending: 'Pending',
    discountedOrder: 'Discounted order',
    refundCodeOrUuid: 'Refund Code',
    refundCodeOrUuidPlaceholder: 'Scan barcode or enter refund code',
    todayTotalLabel: 'Today Total',
    monthTotalLabel: 'Month Total',
  },

  // Audit
  audit: {
    downloadExcel: 'Download Excel',
    excelExport: {
      sheetAudit: 'Audit Log',
      dateTime: 'Date/Time',
      user: 'User',
      role: 'Role',
      action: 'Action',
      entityType: 'Entity Type',
      entityId: 'Entity ID',
    },
    auditLog: 'Audit Log',
    auditTrail: 'Audit Trail',
    action: 'Action',
    actor: 'Actor',
    entityType: 'Entity Type',
    entityId: 'Entity ID',
    timestamp: 'Timestamp',
    details: 'Details',
    oldValue: 'Old Value',
    newValue: 'New Value',
    viewDetails: 'View Details',
    view: 'View',
    filterByAction: 'Filter by Action',
    filterByActor: 'Filter by Actor',
    filterByEntity: 'Filter by Entity',
    allActions: 'All Actions',
    allActors: 'All Actors',
    allEntities: 'All Entities',
    noAuditLogs: 'No audit logs found',
    // Action types
    orderRefunded: 'Order Refunded',
    orderPartiallyRefunded: 'Order Partially Refunded',
    productCreated: 'Product Created',
    productUpdated: 'Product Updated',
    productDeleted: 'Product Deleted',
    sessionOpened: 'Session Opened',
    sessionClosed: 'Session Closed',
    sessionForceClosed: 'Session Force Closed',
    categoryCreated: 'Category Created',
    categoryUpdated: 'Category Updated',
    categoryDeleted: 'Category Deleted',
    offerCreated: 'Offer Created',
    offerUpdated: 'Offer Updated',
    offerDeleted: 'Offer Deleted',
    expenseCreated: 'Expense Created',
    expenseUpdated: 'Expense Updated',
    expenseDeleted: 'Expense Deleted',
    expenseCategoryCreated: 'Expense Category Created',
    expenseCategoryUpdated: 'Expense Category Updated',
    expenseCategoryDeleted: 'Expense Category Deleted',
    purchaseCreated: 'Purchase Created',
    purchaseUpdated: 'Purchase Updated',
    purchaseDeleted: 'Purchase Deleted',
    supplierCreated: 'Supplier Created',
    supplierUpdated: 'Supplier Updated',
    supplierDeleted: 'Supplier Deleted',
    storeDataUpdated: 'Store Data Updated',
    userCreated: 'User Created',
    userUpdated: 'User Updated',
    userDeleted: 'User Deleted',
    userRefundCodeRenewed: 'Code Renewed',
    userAudit: {
      accountCreated: 'Account Created',
      accountUpdated: 'Account Updated',
      accountDeactivated: 'Account Deactivated',
      accountDeleted: 'Account Deleted',
      changes: 'Changes',
      passwordReset: 'Password was reset',
    },
    storeAudit: {
      settingsUpdated: 'Settings Updated',
      changes: 'Changes',
      logoUpdated: 'Logo updated',
    },
    offerAudit: {
      before: 'Before',
      after: 'After',
    },
    allTypes: 'All Types',
    // Entity types
    entityOrder: 'Order',
    entityProduct: 'Product',
    entitySession: 'Session',
    entityRefund: 'Refund',
    entityCategory: 'Category',
    entityExpense: 'Expense',
    entityExpenseCategory: 'Expense Category',
    entityPurchase: 'Purchase',
    entitySupplier: 'Supplier',
    entityStoreData: 'Store Data',
    entityUser: 'User',
    roleAdmin: 'Admin',
    roleOwner: 'Owner',
    roleManager: 'Manager',
    roleCashier: 'Cashier',
    whatHappened: 'What Happened',
    whatChanged: 'What Changed',
    noChangesDetected: 'No changes detected',
    additionalInfo: 'Additional Info',
    setTo: 'Set to',
    actionRecorded: 'Action recorded successfully',
    // Human-readable summaries
    summary: {
      productCreated: '{actor} added a new product: {name}',
      productUpdated: '{actor} updated product: {name}',
      productDeleted: '{actor} deleted product: {name}',
      sessionOpened: '{actor} opened a new session {amount}',
      sessionClosed: '{actor} closed the session {sales}',
      sessionForceClosed: '{actor} force-closed the session',
      orderRefunded: '{actor} refunded an order {amount}',
      orderPartiallyRefunded: '{actor} partially refunded an order {amount}',
      categoryCreated: '{actor} created category: {name}',
      categoryUpdated: '{actor} updated category: {name}',
      categoryDeleted: '{actor} deleted category: {name}',
      offerCreated: '{actor} created offer: {name}',
      offerUpdated: '{actor} updated offer: {name}',
      offerDeleted: '{actor} deleted offer: {name}',
      expenseCreated: '{actor} added an expense {amount}',
      expenseUpdated: '{actor} updated an expense',
      expenseDeleted: '{actor} deleted an expense',
      expenseCategoryCreated: '{actor} created expense category: {name}',
      expenseCategoryUpdated: '{actor} updated expense category: {name}',
      expenseCategoryDeleted: '{actor} deleted expense category: {name}',
      purchaseCreated: '{actor} recorded a purchase {amount}',
      purchaseUpdated: '{actor} updated a purchase',
      purchaseDeleted: '{actor} deleted a purchase',
      supplierCreated: '{actor} added supplier: {name}',
      supplierUpdated: '{actor} updated supplier: {name}',
      supplierDeleted: '{actor} deleted supplier: {name}',
      storeDataUpdated: '{actor} updated store settings',
      userCreated: '{actor} created user: {name}',
      userUpdated: '{actor} updated user: {name}',
      userDeleted: '{actor} deleted user: {name}',
      userRefundCodeRenewed: '{actor} renewed the code for: {name}',
      userDeactivated: '{actor} deactivated user: {name}',
      userReactivated: '{actor} reactivated user: {name}',
      userPasswordReset: '{actor} reset password for user: {name}',
      default: '{actor} performed: {action}',
    },
    summaryNoActor: {
      productCreated: 'Added new product: {name}',
      productUpdated: 'Updated product: {name}',
      productDeleted: 'Deleted product: {name}',
      sessionOpened: 'Opened a new session {amount}',
      sessionClosed: 'Closed the session {sales}',
      sessionForceClosed: 'Force-closed the session',
      orderRefunded: 'Refunded an order {amount}',
      orderPartiallyRefunded: 'Partially refunded an order {amount}',
      categoryCreated: 'Created category: {name}',
      categoryUpdated: 'Updated category: {name}',
      categoryDeleted: 'Deleted category: {name}',
      offerCreated: 'Created offer: {name}',
      offerUpdated: 'Updated offer: {name}',
      offerDeleted: 'Deleted offer: {name}',
      expenseCreated: 'Added an expense {amount}',
      expenseUpdated: 'Updated an expense',
      expenseDeleted: 'Deleted an expense',
      expenseCategoryCreated: 'Created expense category: {name}',
      expenseCategoryUpdated: 'Updated expense category: {name}',
      expenseCategoryDeleted: 'Deleted expense category: {name}',
      purchaseCreated: 'Recorded a purchase {amount}',
      purchaseUpdated: 'Updated a purchase',
      purchaseDeleted: 'Deleted a purchase',
      supplierCreated: 'Added supplier: {name}',
      supplierUpdated: 'Updated supplier: {name}',
      supplierDeleted: 'Deleted supplier: {name}',
      storeDataUpdated: 'Updated store settings',
      userCreated: 'Created user: {name}',
      userUpdated: 'Updated user: {name}',
      userDeleted: 'Deleted user: {name}',
      userRefundCodeRenewed: 'Renewed the code for: {name}',
      userDeactivated: 'Deactivated user: {name}',
      userReactivated: 'Reactivated user: {name}',
      userPasswordReset: 'Reset password for user: {name}',
    },
    // Change descriptions
    changeAdded: 'Added {field}: {value}',
    changeRemoved: 'Removed {field}: {value}',
    changeUpdated: '{field} changed from {oldValue} to {newValue}',
    storeChange: {
      promoRemoved: 'Promo removed',
      promoRemovedDetail: 'Promo removed: {value}',
      promoAdded: 'Promo added',
      promoAddedDetail: 'Promo added: {value}',
      phoneNumbersRemoved: 'Phone numbers removed',
      phoneNumbersRemovedDetail: 'Phone numbers removed: {value}',
      phoneNumbersAdded: 'Phone numbers added',
      phoneNumbersAddedDetail: 'Phone numbers added: {value}',
      socialMediaRemoved: 'Social media links removed',
      socialMediaRemovedDetail: 'Social media links removed: {value}',
      socialMediaAdded: 'Social media links added',
      socialMediaAddedDetail: 'Social media links added: {value}',
      deliveryFeeRemoved: 'Delivery regions removed',
      deliveryFeeRemovedDetail: 'Delivery regions removed: {value}',
      deliveryFeeAdded: 'Delivery regions added',
      deliveryFeeAddedDetail: 'Delivery regions added: {value}',
      itemAdded: 'Added',
      itemRemoved: 'Removed',
      itemUpdated: 'Updated',
      onReceipt: 'On receipt',
    },
    fields: {
      name: 'Name',
      full_name: 'Full Name',
      username: 'Username',
      role: 'Role',
      is_active: 'Status',
      product_name: 'Product Name',
      sku: 'SKU',
      barcode: 'Barcode',
      cost_price: 'Cost Price',
      selling_price: 'Selling Price',
      stock_quantity: 'Stock Quantity',
      category_id: 'Category',
      image_url: 'Image URL',
      category_name: 'Category Name',
      color: 'Color',
      amount: 'Amount',
      date: 'Date',
      notes: 'Notes',
      profit: 'Profit',
      order_total: 'Order Total',
      tax_amount: 'Tax Amount',
      discount_amount: 'Discount Amount',
      payment_method: 'Payment Method',
      opening_cash: 'Opening Cash',
      closing_cash: 'Closing Cash',
      status: 'Status',
      supplier_name: 'Supplier Name',
      supplier_phone: 'Supplier Phone',
      details: 'Details',
      old_value: 'Old Value',
      new_value: 'New Value',
      store_name: 'Store Name',
      address: 'Address',
      phone1: 'Phone 1',
      phone2: 'Phone 2',
      phone3: 'Phone 3',
      website: 'Website',
      low_stock_threshold: 'Low Stock Threshold',
      tax: 'Tax',
      receipt_footer: 'Receipt Footer',
      phone_numbers: 'Phone Numbers',
      social_media_urls: 'Social Media',
      delivery_fee: 'Delivery Fees',
      include_delivery_fee: 'Include Delivery Fee',
      logo_path: 'Store Logo',
      logo_size: 'Logo Size',
      refund_period: 'Refund Period (days)',
      requires_ref_num: 'Require Reference Number',
      discount_requires_approval: 'Discount Requires Approval',
      promo: 'Promo',
      password_changed: 'Password Changed',
    },
  },

  // Settings
  settings: {
    settings: 'Settings',
    general: 'General',
    storeSettings: 'Store Settings',
    storeInformation: 'Store Information',
    storeInformationSubtitle: 'Appears on receipts and reports',
    userManagement: 'User Management',
    systemUsers: 'System Users',
    members: 'members',
    storeName: 'Store Name',
    storeLogo: 'Store Logo',
    uploadLogo: 'Upload Logo',
    changeLogo: 'Change Logo',
    logoHelp: 'Logo will appear on receipts (recommended: square image)',
    logoSize: 'Receipt logo width (px)',
    logoSizeHelp: 'Printed receipt logo width. Allowed range: 40–400.',
    logoSizeInvalid: 'Logo size must be between 40 and 400 pixels.',
    refundPeriod: 'Refund window (days)',
    refundPeriodHelp: 'POS refunds are only allowed for orders from the last N calendar days (1–365).',
    refundPeriodInvalid: 'Refund period must be between 1 and 365 days.',
    storeAddress: 'Store Address',
    address: 'Address',
    phone1: 'Phone 1',
    phone2: 'Phone 2',
    phone3: 'Phone 3',
    phoneNumber: 'Phone Number',
    phoneNumbers: 'Phone Numbers',
    website: 'Website',
    websiteUrl: 'Website URL',
    websiteOnReceipt: 'Website on Receipt',
    dontInclude: "Don't include",
    showAsLink: 'Show as link',
    showAsQr: 'Show as QR code',
    howToDisplayWebsite: 'How to display website on receipts',
    facebook: 'Facebook',
    instagram: 'Instagram',
    tiktok: 'TikTok',
    xTwitter: 'X (Twitter)',
    socialMediaUrls: 'Social Media URLs',
    platform: 'Platform',
    url: 'URL',
    includeInReceipt: 'Include in Receipt',
    lowStockThreshold: 'Low Stock Threshold',
    lowStockThresholdHelp: 'Products below this quantity will be marked as low stock',
    tax: 'Tax (%)',
    receiptFooter: 'Receipt Footer',
    deliveryFees: 'Delivery Fees',
    deliveryRegionsFees: 'Delivery Regions & Fees',
    deliveryFeeSettings: 'Delivery Fee Settings',
    includeDeliveryFeeInSales: 'Include delivery fee in sales total',
    requireRefNumNonCash: 'Require reference number for non-cash payments',
    discountRequiresApproval: 'Require manager/admin approval for discounts',
    allowNegativeStock: 'Allow selling when out of stock',
    allowNegativeStockHelp: 'Cashiers will see a warning instead of being blocked when stock shows 0 or less, and stock quantity may go negative until it is corrected.',
    storePromo: 'Store promo',
    storePromoHelp: 'One active promo applied automatically to all POS orders. Leave empty to disable.',
    promoName: 'Promo name',
    promoNamePlaceholder: 'e.g. Ramadan 10%',
    promoPercentage: 'Promo %',
    clearPromo: 'Clear promo',
    promoEnterBoth: 'Please enter both promo name and percentage',
    promoOnlyOne: 'Only one store promo is allowed. Edit or delete the existing promo first.',
    noStorePromo: 'No active promo. Add one above.',
    deletePromoConfirm: 'Remove this store promo?',
    promoNameRequired: 'Promo name is required when setting a promo percentage',
    promoNameMaxLength: 'Promo name must not exceed 20 characters',
    promoPercentageInvalid: 'Promo percentage must be between 0 and 100 (greater than 0)',
    deliveryFeeIncludedHelp: 'When enabled, delivery fees are included in the total sales amount',
    region: 'Region',
    regionName: 'Region name',
    fee: 'Fee',
    feeEgp: 'Fee (EGP)',
    addRegion: 'Add Region',
    removeRegion: 'Remove Region',
    noDeliveryRegions: 'No delivery regions configured. Add regions above.',
    deliveryPersonnel: 'Delivery Personnel',
    addDeliveryPerson: 'Add Delivery Person',
    deliveryPersonName: 'Name',
    deliveryPersonPhone: 'Phone',
    deliveryPersonNameRequired: 'Name is required',
    deliveryPersonPhoneRequired: 'Phone is required',
    deliveryPersonPhoneUnique: 'This number already exists',
    deleteDeliveryPersonConfirm: 'Delete this delivery person?',
    noDeliveryPersons: 'No delivery persons yet.',
    noPhoneNumbers: 'No phone numbers configured. Add phone numbers above.',
    noSocialMedia: 'No social media URLs configured. Add URLs above.',
    saveSettings: 'Save Settings',
    saveChanges: 'Save Changes',
    saving: 'Saving...',
    saved: 'Saved',
    settingsSaved: 'Settings saved successfully',
    users: 'Users',
    addUser: 'Add User',
    addNewUser: 'Add New User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    username: 'Username',
    usernameTaken: 'This username is already taken',
    password: 'Password',
    newPasswordOptional: 'New Password (optional)',
    confirmPassword: 'Confirm Password',
    fullName: 'Full Name',
    role: 'Role',
    admin: 'Admin',
    owner: 'Owner',
    manager: 'Manager',
    cashier: 'Cashier',
    ownerAccountProtected: 'The store owner account cannot be changed by others.',
    ownerChangePasswordHint: 'You can only change your password here.',
    adminChangePasswordHint: 'You can only change your password here.',
    roleNotAllowed: 'You do not have permission to assign this role.',
    canApproveDiscounts: 'Can approve discounts',
    canApproveDiscountsHint: 'Allows this user’s refund code to authorize POS discounts.',
    active: 'Active',
    inactive: 'Inactive',
    activate: 'Activate',
    deactivate: 'Deactivate',
    confirmToggleActivateVerb: 'activate',
    confirmToggleDeactivateVerb: 'deactivate',
    userStatus: 'Status',
    confirmDeleteUser: 'Are you sure you want to delete this user?',
    confirmToggleStatus: 'Are you sure you want to {action} {name}?',
    userAdded: 'User added successfully',
    userUpdated: 'User updated successfully',
    userDeleted: 'User deleted successfully',
    passwordMismatch: 'Passwords do not match',
    fullNameMaxLength: 'Full name must not exceed 40 characters',
    usernameMaxLength: 'Username must not exceed 20 characters',
    passwordLength: 'Password must be between 4 and 30 characters',
    allRoles: 'All Roles',
    allStatuses: 'All Statuses',
    filterByRole: 'Filter by Role',
    filterByStatus: 'Filter by Status',
    clearFilters: 'Clear Filters',
    searchUsers: 'Search users...',
    searchUsersByNameOrUsername: 'Search by name or username…',
    usersNoSearchMatches: 'No users match your search.',
    cannotEditSelf: 'You cannot change your own role',
    managersCanOnlyEditCashiers: 'Managers can only edit cashier users',
    managersCanOnlyCreateCashiers: 'Managers can only create cashier users',
    managersCannotChangeRoles: 'Managers cannot change user roles',
    managerChangePasswordHint: 'Enter your new password.',
    newPassword: 'New password',
    cannotDeactivateSelf: 'Cannot deactivate yourself',
    cannotDeleteSelf: 'Cannot delete yourself',
    license: 'License',
    licenseTabSubtitle: "This device's activation status",
    licenseChecking: 'Checking license…',
    licenseServerMobileLink: 'Mobile Server Link',
    licenseServerMobileLinkNotSet: 'Not set',
    licenseBootstrapClosedHint:
      'Ask your store administrator to activate this till from Settings → License on the main cashier.',
    licenseSlotsTitle: 'Registers',
    licenseSlotsSubtitle:
      'Activate extra license slots for additional till PCs (after the first machine has completed setup).',
    licenseSlotsLicenseMeta: 'License key: {key} · Max slots: {max}',
    licenseSlotsSync: 'Sync now',
    licenseSlotsLoading: 'Loading slots…',
    licenseSlotsEmpty: 'No slots found for this license key.',
    licenseSlotsColSlot: 'Slot ID',
    licenseSlotsColStatus: 'Server status',
    licenseSlotsColTill: 'Bound till',
    licenseSlotsColActions: 'Actions',
    licenseSlotsStatus_active: 'Active',
    licenseSlotsStatus_pending: 'Pending',
    licenseSlotsStatus_revoked: 'Revoked',
    licenseSlotsActivate: 'Activate till',
    licenseSlotsActivating: 'Activating…',
    licenseSlotsActivateTitle: 'Activate new till',
    licenseSlotsSlotLabel: 'Slot:',
    licenseSlotsTillName: 'Till name',
    licenseSlotsTillNamePlaceholder: 'e.g. Front counter',
    licenseSlotsTillNameRequired: 'Till name is required',
    licenseSlotsTillNameTooLong: 'Name must be 50 characters or less',
    licenseSlotsActivationFailed: 'Activation failed',
    licenseSlotsActivatedNamed: '"{name}" activated',
    licenseSlotsRegisterUuidHint: 'Register UUID — give this to the till operator',
    licenseSlotsUnbind: 'Unbind',
    licenseSlotsUnbinding: 'Unbinding…',
    licenseSlotsUnbindTitle: 'Unbind slot?',
    licenseSlotsBoundTo: 'Currently bound to "{name}"',
    licenseSlotsUnbindWarning:
      'This only clears the local binding and token. The slot is NOT revoked on the license server — do that separately via the license server admin.',
    licenseSlotsUnbindFailed: 'Unbind failed',
    licenseSlotsRevokedHint: 'Reset on license server first',
    licenseBannerExpiresOneDay: 'License expires in 1 day.',
    licenseBannerExpiresDays: 'License expires in {days} days.',
    licenseBannerDaysRemainingOne: '1 day remaining',
    licenseBannerDaysRemaining: '{days} days remaining',
    licenseBannerDismiss: 'Dismiss',
    // Tabs
    database: 'Database',
    databaseInfo: 'Data is stored on the store server (PostgreSQL). Create backups, restore from backup, or drop all data. Admin only.',
    databaseBackup: 'Backup',
    databaseUpload: 'Upload / Restore',
    databaseDrop: 'Drop All Data',
    databaseDropTransactional: 'Drop Transactional Data',
    databaseDropTransactionalConfirm:
      'Drop orders, sessions, refunds, etc.? Users, products, categories, registers, store data, license configuration, customers, suppliers, and delivery persons will be preserved. Continue?',
    databaseDropTransactionalSuccess:
      'Transactional data dropped. Users, products, categories, registers, store data, customers, suppliers, and delivery persons preserved.',
    databaseDropTransactionalSuccessResetSessions:
      'Transactional data dropped and session numbers reset. Users, products, categories, registers, store data, license configuration, customers, suppliers, and delivery persons preserved.',
    databaseResetSessionsLabel: 'Reset session numbers (optional)',
    databaseResetSessionsPlaceholder: 'Type RESET_SESSIONS to reset',
    databaseResetSessionsHint: 'Leave empty to keep the next session number as-is. Type RESET_SESSIONS exactly to restart session numbering from 1.',
    databaseDropDescription:
      'What this does:\n• Clears nearly everything in the database except your user accounts, POS registers, and license configuration.\n• Store settings, products, categories, customers, orders, sessions, and all other table rows are removed.\n• Session numbering restarts from 1.\n• Recover only by restoring a backup.',
    databaseDropTransactionalDescription:
      'What this does:\n• Removes sales and operational records: register sessions, orders, payments, refunds, expenses, purchases from suppliers, monthly closings, and audit logs.\n• Keeps unchanged: users, products, categories, registers, store settings, license configuration, customers, suppliers, and delivery persons.\n• Optional: type RESET_SESSIONS in the field below to restart session numbering from 1; leave it empty to keep the next session number.',
    databaseAdminPasswordHint: 'Enter your admin password to confirm this action.',
    databasePasswordRequired: 'Admin password is required.',
    databaseSelectFile: 'Please select a .sql backup file.',
    databaseRestoreSuccess: 'Database restored successfully.',
    databaseBackupConfirm: 'Create database backup?',
    databaseUploadConfirm: 'Restore database from backup?',
    databaseDropConfirm:
      'Drop all data? User accounts and registers will be preserved so you can restore from backup. Continue?',
    databaseBackupRecommendation: 'Recommendation: Take a backup first before proceeding.',
    databaseDropSuccess:
      'All data has been dropped and session numbers reset. User accounts and registers preserved. You can restore from backup.',
    adminPassword: 'Admin password',
    invalidAdminPassword: 'Invalid admin password',
    security: 'Security',
    securityInfo: 'Session timeout and security are managed by the application. Change password via Edit User in User Management.',
    about: 'About',
    aboutAppName: 'Numuw Counter',
    aboutTagline: 'Point of Sale System',
    aboutInfo: 'Numuw Counter – cloud point of sale. Your store data runs on Numuw Counter Cloud.',
    aboutCompany: 'A product by Numuw',
    aboutWebsite: 'Website',
    aboutScanQr: 'Scan to visit the website',
    aboutSupport: 'Technical support & inquiries',
    aboutWhatsapp: 'WhatsApp',
    barcode: 'Barcode',
    uuidBarcodePrinting: 'UUID Barcode Printing',
    printBarcodeForAdminManager: 'Print UUID barcodes for admin and manager users. These barcodes are used for the refund approval process or discounts.',
    printYourBarcode: 'Print your UUID barcode for the refund approval process.',
    printBarcode: 'Print Barcode',
    downloadBarcode: 'Download',
    refundCode: 'Code',
    loadingUsers: 'Loading users...',
    noUsersAvailable: 'No users available.',
    searchRefundBarcodeUsers: 'Search by name, username, or refund code…',
    noRefundBarcodeFilterMatch: 'No users match your filters.',
    accessDenied: 'Access denied. Only administrators and managers can print UUID barcodes.',
    forRefundApproval: 'For refund approval process or discounts',
    cashiersSection: 'Cashiers',
    renewCode: 'Renew Code',
    renewCodeWarning: "This will immediately invalidate {name}'s current code. Anyone using the old code will be rejected instantly. Continue?",
    confirmRenew: 'Yes, Renew',
    renewCodeSuccess: 'Code renewed successfully.',
    renewCodeFailed: 'Failed to renew the code. Please try again.',
  },

  // Error messages
  errors: {
    somethingWentWrong: 'Something went wrong',
    tryAgain: 'Please try again',
    networkError: 'Network error. Please check your connection.',
    unauthorized: 'Unauthorized. Please login again.',
    forbidden: 'You do not have permission to perform this action.',
    notFound: 'Resource not found.',
    serverError: 'Server error. Please try again later.',
    validationError: 'Please check your input and try again.',
    sessionExpired: 'Your session has expired. Please login again.',
  },

  // Confirmations
  confirm: {
    delete: 'Are you sure you want to delete this item?',
    logout: 'Are you sure you want to logout?',
    clearCart: 'Are you sure you want to clear the cart?',
    cancelOrder: 'Are you sure you want to cancel this order?',
    closeSession: 'Are you sure you want to close this session?',
  },

  // Currency
  currency: {
    egp: 'EGP',
    symbol: 'E£',
  },

  // Alert messages
  alerts: {
    // POS alerts
    invalidWeightBarcode: 'Invalid weight barcode format',
    itemNotFoundForSku: 'Item not found for SKU: {sku}',
    itemNotFoundForBarcode: 'Item not found for barcode: {barcode}',
    itemNotWeightConfigured: 'Item "{name}" is not configured as a weight item',
    itemOutOfStock: 'Item is out of stock: {name}',
    notEnoughStockAvailable: 'Not enough stock available. Available: {available} {unit}',
    notEnoughStockForItem: 'Not enough stock available for: {name}. Total stock: {total}, In cart: {inCart}, Available: {available}',
    sellingWithoutStock: 'No recorded stock for {name} - selling anyway. Please recount and update inventory soon.',
    noOpenSession: 'No open session. Please open a session first.',
    pleaseSelectDeliveryRegion: 'Please select a delivery region.',
    customerPhoneRequired: 'Customer phone is required for delivery orders.',
    customerNameRequired: 'Customer name is required for delivery orders.',
    customerAddressRequired: 'Customer address is required for delivery orders.',
    deliveryPersonRequired: 'Please select a delivery person.',
    cartIsEmpty: 'Cart is empty',
    cashMustBeGreaterOrEqual: 'Cash amount must be greater than or equal to total amount',
    pleaseEnterTransactionNumber: 'Please enter transaction number',
    pleaseEnterCashAmount: 'Please enter cash amount',
    cashMustBeLessThanTotal: 'Cash amount must be less than total amount for mixed payment',
    mixedMinCashAmount: 'Cash amount must be at least 1 EGP for mixed payment',
    mixedMinInstapayAmount: 'InstaPay amount must be at least 1 EGP in mixed payment',
    mixedMinWalletAmount: 'Wallet amount must be at least 5 EGP in mixed payment',
    mixedNotAvailableForTotal: 'Mixed payment is not available for this order total with the selected method',
    pleaseEnterCardTransaction: 'Please enter card transaction number',
    pleaseEnterInstapayTransaction: 'Please enter instapay transaction number',
    pleaseEnterWalletTransaction: 'Please enter wallet transaction number',
    paymentRefMaxLength: 'Payment reference number must not exceed 50 characters',
    refundReasonMaxLength: 'Refund notes must not exceed 150 characters',
    discountNotesMaxLength: 'Discount notes must not exceed 50 characters',
    reviewNotesMaxLength: 'Session review notes must not exceed 250 characters',
    forceCloseNotesMaxLength: 'Force-close notes must not exceed 150 characters',
    invalidUuidFormat: 'Please enter a valid UUID format (e.g. xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)',
    failedToPrintReceipt: 'Failed to print receipt. Please try again.',
    pleasePrintReceiptFirst: 'Please print the receipt first',
    openingAmountNegative: 'Opening amount cannot be negative',
    closingAmountNegative: 'Closing amount cannot be negative',
    transactionFailed: 'Transaction failed: {message}. Please try again.',
    customerDeleteDeliveryPersonConflict: 'Cannot delete customer: this customer has delivery orders with assigned delivery persons. Please remove the delivery person from those orders first.',
    insufficientStockForCheckout: 'Insufficient stock for "{name}". Available: {available}. Another sale may have been completed at the same time.',
    quantityReducedToAvailable: 'Quantity reduced to available stock for "{name}" ({available}). Another sale may have occurred. Please try checkout again.',
    itemRemovedOutOfStock: '"{name}" removed from cart – out of stock. Another sale may have occurred. Please try checkout again.',
    transactionInProgressConfirm: 'Transaction in progress. Are you sure you want to leave?',

    // Inventory alerts
    failedToSave: 'Failed to save: {error}',
    failedToSaveCategory: 'Failed to save category: {error}',
    itemNameRequired: 'Item name is required',
    categoryRequired: 'Please select a category',
    stockQuantityInvalid: 'Stock quantity must be 0 or greater',
    costPriceNegative: 'Cost price cannot be negative',
    sellingPriceNegative: 'Selling price cannot be negative',
    profitMarginNegative: 'Selling price must be equal to or greater than cost price so profit is not negative.',
    purchaseUnitPriceInvalid: 'Unit price must be greater than 0.',
    purchaseSellingBelowUnitCost: 'Unit selling price must be equal to or greater than unit cost so profit is not negative.',
    purchaseQuantityPieceWholeNumber: 'Quantity must be a whole number for products tracked by piece.',
    purchaseQuantityKgMaxDecimals: 'Quantity may have at most 3 digits after the decimal point for products tracked by kg.',
    deleteFailed: 'Delete failed',
    productHasPurchases: 'Cannot delete this product because it has associated purchase records. Remove the purchases first.',
    productReferenced: 'Cannot delete this product because it is referenced by other records (e.g. orders, purchases).',
    productInOffer: 'Cannot delete this product because it is used in one or more offers. Remove it from the offers first.',
    categoryHasProductsInOffers: 'Cannot delete this category because it contains products used in one or more offers. Remove those products from the offers first.',
    categoryHasProductsWithPurchases:
      'Cannot delete this category because it contains products that have purchase records. Move or delete those products or their purchases first.',
    productPurchaseRestrict: 'Cannot delete this product because it has associated purchase records. Remove the purchases first.',

    // Settings alerts
    enterBothRegionAndFee: 'Please enter both region and fee',
    feeMustBePositive: 'Fee must be a valid positive number',
    regionAlreadyExists: 'Region already exists',
    pleaseEnterPhoneNumber: 'Please enter a phone number',
    phoneNumberAlreadyExists: 'This phone number already exists',
    pleaseEnterUrl: 'Please enter a URL',
    platformAlreadyExists: 'This platform already exists',
    deleteDeliveryRegion: 'Delete this delivery region?',
    deletePhoneNumber: 'Delete this phone number?',
    deleteSocialMedia: 'Delete this social media URL?',
    failedToGenerateBarcode: 'Failed to generate barcode',
    storeNameMaxLength: 'Store name must not exceed 20 characters',
    addressMaxLength: 'Address must not exceed 50 characters',
    websiteMaxLength: 'Website URL must not exceed 40 characters',
    receiptFooterMaxLength: 'Receipt footer must not exceed 50 characters',
    regionNameMaxLength: 'Delivery region name must not exceed 20 characters',
    phoneNumberMaxLength: 'Phone number must not exceed 15 characters',
    socialUrlMaxLength: 'Social media link must not exceed 70 characters',
    deliveryPersonNameMaxLength: 'Delivery person name must not exceed 30 characters',
    deliveryPersonPhoneMaxLength: 'Delivery person phone must not exceed 15 characters',
    customerNameMaxLength: 'Customer name must not exceed 30 characters',
    customerPhoneMaxLength: 'Customer phone must not exceed 15 characters',
    customerAddressMaxLength: 'Customer address must not exceed 70 characters',
    posDeliveryAddressMaxLength: 'Delivery address must not exceed 50 characters',
    supplierNameMaxLength: 'Supplier name must not exceed 30 characters',
    supplierPhoneMaxLength: 'Supplier phone must not exceed 15 characters',
    expenseNameMaxLength: 'Expense name must not exceed 50 characters',
    expenseCategoryNameMaxLength: 'Expense category name must not exceed 30 characters',
    inventoryCategoryNameMaxLength: 'Category name must not exceed 30 characters',
    productNameMaxLength: 'Product name must not exceed 40 characters',
    productSkuMaxLength: 'Product SKU must not exceed 50 characters',

    // Session alerts
    enterValidClosingCash: 'Please enter a valid closing cash value.',
    closingCashMustBeNonNegative: 'Closing cash must be 0 or greater.',
    managersCannotEditReviewed: 'Managers cannot edit an already reviewed session.',
    failedToForceCloseSession: 'Failed to force-close session',
    failedToReviewSession: 'Failed to review session',
    failedToOpenSession: 'Failed to open session',
    failedToCloseSession: 'Failed to close session',

    // Refund alerts
    failedToLoadRefund: 'Failed to load refund details',
    pleaseEnterReceiptNumber: 'Please enter a receipt number',
    orderNotFoundOrOlderThanOneDay: 'Order not found or order is older than 1 day',
    orderNotFoundOrOlderThanDays: 'Order not found or order is older than {days} days',
    failedToFindOrder: 'Failed to find order',
    pleaseEnterApproverUuid: 'Please enter manager/admin UUID',
    pleaseEnterApproverCode: 'Please enter manager/admin refund code or UUID',
    invalidApproverFormat: 'Please enter a valid 16-character refund code or UUID',
    invalidApprover: 'Invalid approver: UUID or refund code must belong to a manager or admin',
    inactiveApprover: 'This approver account is inactive. Use an active manager or admin code.',
    noDiscountPermission: 'This approver is not allowed to approve discounts.',
    failedToProcessRefund: 'Failed to process refund',
    orderAlreadyRefunded: 'This order has already been refunded',

    // User/Settings alerts
    failedToUpdateUserStatus: 'Failed to update user status',
    usernameAlreadyTaken: 'This username is already taken',
    failedToCreateUser: 'Failed to create user',
    failedToUpdateUser: 'Failed to update user',
    deleteUserConfirm: 'Delete this user?',
    failedToDeleteUser: 'Failed to delete user',

    // Load/Save fallbacks
    failedToLoadRefunds: 'Failed to load refunds',
    failedToLoadPurchases: 'Failed to load purchases',
    failedToLoadSales: 'Failed to load sales',
    failedToLoadCustomers: 'Failed to load customers',
    failedToLoadDeliveryPersons: 'Failed to load delivery persons',
    failedToLoadExpenses: 'Failed to load expenses',
    failedToSaveSupplier: 'Failed to save supplier',
    failedToDeletePurchase: 'Failed to delete purchase',
    failedToSaveExpense: 'Failed to save expense',
    failedToSaveExpenseCategory: 'Failed to save expense category',
    failedToDeleteExpense: 'Failed to delete expense',
    failedToDeleteExpenseCategory: 'Failed to delete expense category',

    // General
    unknownError: 'Unknown error',
    failedToUpdate: 'Failed to update',
    confirmDelete: 'Are you sure you want to delete this?',
  },
};

export default en;
